import ACTIONS from 'constants/actionTypes';

export interface LayoutConfiguration {
  isSearchExpanded: boolean;
  isHelpdeskExpanded: boolean;
  isMenuExpanded?: boolean;
  menuVersion?: 'old' | 'new';
  isNewMenuNotified?: boolean;
}

const initialState: LayoutConfiguration = {
  isMenuExpanded: undefined,
  menuVersion: undefined,
  isNewMenuNotified: undefined,
  isSearchExpanded: false,
  isHelpdeskExpanded: false,
};

interface UpdateLayoutConfigurationAction {
  type: ACTIONS.UPDATE_LAYOUT_CONFIGURATION;
  payload: Partial<Pick<LayoutConfiguration, keyof LayoutConfiguration>>;
}

export const layoutConfiguration = (
  state = initialState,
  action:
    | UpdateLayoutConfigurationAction
    | { type: ACTIONS.RESET_ALL; payload?: never }
) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.UPDATE_LAYOUT_CONFIGURATION:
      return {
        ...state,
        ...payload,
      };

    case ACTIONS.RESET_ALL:
      return initialState;

    default:
      return state;
  }
};
